export default {"src":"/_next/static/media/xmy.39ab4f92.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};